import React, { useCallback } from 'react';
import { MCButton, ToggleSwitch } from '../../basic';
import { lang, remCss, scssVariables as variables } from 'src/helpers';
import SVGIcon, { BASE_ICONS } from '../../svg';
import LANG_CONST from 'src/helpers/lang/const';
import { WorkingDays } from './WorkingDays';
import { generateWorkingWeeks } from '../utils';
import moment from 'moment';

export const WorkingWeeks = (props) => {
  const { weeks, setWeeks, invalid, days } = props;
  const [openId, setOpenId] = React.useState(null);

  const handleChange = useCallback(
    (weekIndex, key, value) => {
      const old = JSON.parse(JSON.stringify(weeks));
      old[weekIndex][key] = value;
      setWeeks(old);
    },
    [weeks, setWeeks]
  );

  if (weeks.length === 1) {
    return (
      <div className='mc-modal-body mc-flex-col' style={{ flex: 1, gap: remCss(30) }}>
        <WorkingDays
          {...props}
          onlyList={true}
          invalid={invalid?.weeks ? invalid?.weeks[0] : {}}
          days={weeks[0].days}
          onlyContent={true}
          key={0 + '_day'}
          setDays={(value) => {
            if (typeof value !== 'function') return handleChange(0, 'days', value);
            handleChange(0, 'days', value(weeks[0].days));
          }}
        />
      </div>
    );
  }

  return (
    <div className='mc-modal-body mc-flex-col' style={{ flex: 1, gap: remCss(30) }}>
      {weeks.length < 5 && (
        <div style={{ position: 'absolute', top: 12, right: 20 }}>
          <MCButton
            primary
            label={LANG_CONST.buttons.apply_full_year}
            large
            onClick={() =>
              setWeeks(
                generateWorkingWeeks(days, moment().valueOf(), moment().endOf('year').valueOf())
              )
            }
          />
        </div>
      )}
      {weeks.map((week, weekIndex) => {
        const { enabled, label, id, days } = week;
        return (
          <div className={'mc-flex-col mc-radius-5 mc-p20 mc-b2'} key={weekIndex}>
            <div className={'mc-grow mc-flex-20'}>
              <ToggleSwitch
                checked={enabled}
                onChange={() => handleChange(weekIndex, 'enabled', !enabled)}
              />
              <div
                onClick={() => handleChange(weekIndex, 'enabled', !enabled)}
                className={'mc-value-520 mc-pointer'}
              >
                {lang.t(label)}
              </div>
              <div className={'mc-grow mc-flex-col mc-flex-end'}>
                <MCButton
                  onClick={() => setOpenId((o) => (o === id ? null : id))}
                  medium
                  primary
                  light
                  radius
                  style={{
                    paddingLeft: remCss(10),
                    paddingRight: remCss(5),
                    paddingVertical: remCss(5)
                  }}
                >
                  <span>{lang.t(LANG_CONST.buttons.edit)}</span>
                  <span
                    className={'mc-rotate ' + (openId === id ? 'mc-rotate-180' : '')}
                    style={{ height: remCss(30) }}
                  >
                    <SVGIcon
                      iconname={BASE_ICONS.DOWN}
                      width={30}
                      padding={1}
                      fill={variables['colors-mc-primary']}
                    />
                  </span>
                </MCButton>
              </div>
            </div>

            <div className={'mc-grow mc-flex-20-col mc-pt20 ' + (openId === id ? '' : 'mc-hide')}>
              {openId === id && (
                <WorkingDays
                  {...props}
                  invalid={invalid?.weeks ? invalid?.weeks[weekIndex] : {}}
                  days={days}
                  onlyContent={true}
                  key={weekIndex}
                  setDays={(value) => {
                    if (typeof value !== 'function') return handleChange(weekIndex, 'days', value);
                    handleChange(weekIndex, 'days', value(days));
                  }}
                />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
